export default "./dist/stdassets/images/icons/geolocation.png";